import { api } from "@/lib/api";

const b64url = (buf) =>
  btoa(String.fromCharCode(...new Uint8Array(buf))).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");

const randomString = () => b64url(crypto.getRandomValues(new Uint8Array(32)).buffer);

export const redirectUri = () => `${window.location.origin}/auth/callback`;

export async function getSsoConfig() {
  const r = await api.get("/auth/config");
  return r.data;
}

export async function beginSocialPulseLogin() {
  const cfg = await getSsoConfig();
  if (!cfg.enabled) return false;
  const verifier = randomString();
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  const nonce = randomString();
  const state = randomString();
  sessionStorage.setItem("sp_oidc", JSON.stringify({ verifier, nonce, state }));
  const q = new URLSearchParams({
    response_type: "code",
    client_id: cfg.client_id,
    redirect_uri: redirectUri(),
    scope: "openid profile email",
    code_challenge: b64url(digest),
    code_challenge_method: "S256",
    nonce,
    state,
  });
  window.location.assign(`${cfg.authorization_endpoint}?${q}`);
  return true;
}

export async function finishSocialPulseLogin() {
  const p = new URLSearchParams(window.location.search);
  const tx = JSON.parse(sessionStorage.getItem("sp_oidc") || "null");
  sessionStorage.removeItem("sp_oidc");
  if (!tx || !p.get("code") || p.get("state") !== tx.state) throw new Error("Invalid or expired login attempt");
  const r = await api.post(
    "/auth/socialpulse/callback",
    { code: p.get("code"), code_verifier: tx.verifier, nonce: tx.nonce, redirect_uri: redirectUri() },
    { withCredentials: true }
  );
  window.dispatchEvent(new Event("mp-auth-changed"));
  return r.data.user;
}

export async function getMe() {
  try {
    const r = await api.get("/auth/me", { withCredentials: true });
    return r.data;
  } catch {
    return null;
  }
}

export async function logout() {
  await api.post("/auth/logout", {}, { withCredentials: true });
  window.dispatchEvent(new Event("mp-auth-changed"));
}
